var map = {
	"./collections-mock": [
		62907,
		[
			"src_mocks_collections-mock_ts"
		]
	],
	"./collections-mock.ts": [
		62907,
		[
			"src_mocks_collections-mock_ts"
		]
	],
	"./mock-utils": [
		74847,
		[
			"src_mocks_mock-utils_ts"
		]
	],
	"./mock-utils.ts": [
		74847,
		[
			"src_mocks_mock-utils_ts"
		]
	],
	"./sponsors-mock": [
		29719,
		[
			"src_mocks_sponsors-mock_ts"
		]
	],
	"./sponsors-mock.ts": [
		29719,
		[
			"src_mocks_sponsors-mock_ts"
		]
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6635;
module.exports = webpackAsyncContext;